<template>
  <div :class="{
    'iqos': true,
    'iqos-warning': !!warning
  }">
    <h3 :class="{
     'title-box': true,
     'title-box-warning': !!warning
    }" v-if="!hideTitle">
      <slot name="header">
        <img
          src="/icons/iqos-header-warning-icon.svg"
          class="iqos-header-warning-icon"
          v-if="warning"/>{{ title
        }}<span v-if="warning">
          <span class="iqos-integration-warning-label" v-if="warning !== true">{{ warning }}</span></span
        >
      </slot>
    </h3>

    <div :class="dynamicClass" :readonly="readonly">
      <slot></slot>
    </div>

    <slot name="ordersTable"></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: String,

    warning: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: true,
    },

    hideTitle: {
      type: Boolean,
      default: false,
    },

    boxClass: {
      type: String,
      default: "",
    },
    // staticIQOS: {
    //   type:Boolean,
    //   default:false
    // }
  },
  computed: {
    dynamicClass() {
      return {
        "container-box": true,
        "iqos-static": !this.readonly,
        [this.boxClass]: true,
        "p-0": this.hideTitle,
      };
    },
  },
};
</script>

<style>
.iqos-bottom-comment {
  margin-bottom: 0;
  margin-top: 1vh;
}
.iqos-header-warning-icon {
  /* width: 3.222vh;
  height: 3.222vh; */
  width: 2.6vh;
  height: 2.6vh;
  margin-right: 1.111vh;
}
.iqos-integration-active-label {
  color: #129b81;
}
.iqos-integration-warning-label {
  color: #f96d1e;
}

.title-box-warning {
  display:flex;
  align-items: center;
}
</style>
